/**
 * reportRouteMemory.js — REP-10 PA-3. Which screen a report from Settings is about.
 *
 * A patient who hits a problem on a screen goes to Settings to report it, so the screen the
 * report is about is the last one she was on BEFORE Settings. App.jsx calls rememberReportRoute
 * on every navigation — only while REPORT_PROBLEM_ENABLED is on.
 *
 * ★★ ONLY THE TEMPLATE IS HELD. routeNameFor turns '/case/8f3c…' into '/case/:caseId' before
 *   anything is stored; the pathname itself is never kept. In memory only: nothing is written
 *   to storage, and a reload forgets it (the report then carries no route, which is the
 *   server's "nothing to report", not its alarm).
 */
import { routeNameFor, isSettingsPattern, UNKNOWN_ROUTE } from './bugReport'

let lastPattern = null

export function rememberReportRoute(pathname) {
  const pattern = routeNameFor(pathname)
  if (pattern === UNKNOWN_ROUTE || isSettingsPattern(pattern)) return
  lastPattern = pattern
}

export function lastReportRoutePattern() {
  return lastPattern
}
